import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { AbstractModal, ModalComponent, ModalViewerService } from '@nesea/ngx-ui-kit/modal';
import { IModalInput, IModalOutput } from '@nesea/ngx-ui-kit/shared';
import { IUser } from '@core/models/interfaces/user.interface';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { InputComponent } from '@nesea/ngx-ui-kit/form';

export interface IProfileModalInput extends IModalInput {
  user?: IUser;
  timebank?: number;
}
export interface IProfileModalOutput extends IModalOutput { }

@Component({
  selector: 'nsf-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrl: './profile-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
    ModalComponent,
    InputComponent
  ]
})
export class ProfileModalComponent extends AbstractModal<IProfileModalInput, IProfileModalOutput> {

  moreInfo = model(false);

  initials = computed(() => {
    const n = this.data?.user?.name?.trim() ?? '';
    const l = this.data?.user?.lastname?.trim() ?? '';
    return ((n.charAt(0) || '') + (l.charAt(0) || '')).toUpperCase() || '?';
  });

  timebank = computed(() => {
    const { hours, minutes } = this._convertHoursToTime(this.data.timebank ?? 0);
    return `${hours}h : ${minutes}m`;
  });

  constructor(
    protected override modalViewerService: ModalViewerService
  ) {
    super(modalViewerService);
  }

  override onInit(): void {}
  override onDestroy(): void {}

  toggleMoreInfo(): void {
    this.moreInfo.update(value => !value);
  }

  private _convertHoursToTime(dHours: number): { hours: string, minutes: string } {
    const hours = Math.floor(dHours);
    const minutes = Math.round((dHours - hours) * 60);
    return { hours: `${hours}`.padStart(2, '0'), minutes: `${minutes}`.padStart(2, '0') };
  }

}
